import styled from "styled-components";

export const CmpFileInput = styled.div`
  .input-container {
    display: flex;
    align-items: center;
    .upload-document {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12.5px 20px;
      min-width: 200px;
      background-color: #F0F0FF;
      border-radius: 14px;
      cursor: pointer;  
      font-size: 18px;
      color: #0C0AA2;
      &--delete {
        justify-content: flex-start;
      }
      .close-icon {
        font-size: 9px;
        margin-right: 14px;
      }
    }
    .separator {
      height: 14px;
      border-left: 1px solid #CFD3DD;
    }
    .document-container {
      display: flex;
      width: 100%;
      align-items: center;
      color: #3E3E5B;
      margin-left: 10px;
      font-size: 20px;
      &__icon {
        color: #3E3E5B;
        padding: 3px 4px;
        font-size: 11px;
        cursor: pointer;
        margin-right: 10px;
      }
    }
    .document-label {
      font-size: 20px;
      color: #707582;
      margin-left: 20px;
    }
  }
`;
